var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLoader2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 7.18763 17.2085 3.25304 12.4346 3.01172L11.9698 3L11.8672 2.99512C11.3629 2.94394 10.9698 2.51779 10.9698 2C10.9698 1.44772 11.4175 1 11.9698 1L12.5372 1.01465C18.3628 1.30927 23 6.11205 23 12C23 18.0779 18.0588 22.9998 11.9698 23C6.4712 23 1.90966 18.9875 1.07524 13.7334L1.0059 13.2217L1.00004 13.1191C0.995362 12.6124 1.37515 12.1743 1.88969 12.1172C2.40416 12.0601 2.87094 12.4041 2.97758 12.8994L2.99418 13.001L3.05082 13.4199C3.73319 17.7132 7.46508 21 11.9698 21C16.96 20.9998 21 16.9676 21 12Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLoader2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconLoader2.dd2dda2dfeb0d6001972b916598e72d4.svg";